import { render, staticRenderFns } from "./deliveryTask.vue?vue&type=template&id=7e082752&scoped=true&"
import script from "./deliveryTask.vue?vue&type=script&lang=js&"
export * from "./deliveryTask.vue?vue&type=script&lang=js&"
import style0 from "./deliveryTask.vue?vue&type=style&index=0&id=7e082752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e082752",
  null
  
)

export default component.exports